module.exports = __webpack_public_path__ + "img/pn.9ce9d8ce.svg";